import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { FormControl, Validators, FormGroup, FormBuilder, ValidatorFn, AbstractControl } from '@angular/forms';
import * as $ from 'jquery';
import { TranslateService } from '@ngx-translate/core';
import { BankService } from "../../services/bank.service";
import { BankModel } from "../../models/bank.model";
import { FailComponent } from '../../../shared/toast/fail/fail.component';

export interface IDialogData {
  objectId: string;
  objectType: string;
  bankId: string;
  mode: string;
  message: string;
  bankCreated: boolean;
  bankEdited: boolean;
  ok: boolean;
}

@Component({
  selector: 'app-bankpopup',
  templateUrl: './bankpopup.component.html',
  styleUrls: ['./bankpopup.component.css']
})
export class BankpopupComponent implements OnInit {
  emptyGuid: string = '00000000-0000-0000-0000-000000000000';
  auth: any = JSON.parse(sessionStorage.getItem("auth"));
  createBankForm: FormGroup;
  accountNumberControl: FormControl;
  bankNameControl: FormControl;
  bankNameDetailControl: FormControl;
  branchControl: FormControl;
  accountUserControl: FormControl;

  bankModel: BankModel = {
    BankAccountId: this.emptyGuid,
    ObjectId: this.data.objectId,
    ObjectType: this.data.objectType,
    AccountNumber: '',
    BankName: '',
    BankDetail: '',
    BranchName: '',
    AccountName: '',
    CreatedById: this.auth.UserId,
    CreatedDate: new Date(),
    UpdatedById: '',
    UpdatedDate: null,
    Active: true
  }

  failConfig: MatSnackBarConfig = { panelClass: 'fail-dialog', horizontalPosition: 'end', duration: 5000 };

  constructor(private el: ElementRef,
    private translate: TranslateService,
    private bankService: BankService,
    public dialogRef: MatDialogRef<BankpopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogData,
    public snackBar: MatSnackBar) {
    translate.setDefaultLang('vi');
  }

  ngOnInit() {
    this.accountNumberControl = new FormControl('',[Validators.required]);
    this.bankNameControl = new FormControl('',[Validators.required]);
    this.branchControl = new FormControl('',[Validators.required]);
    this.accountUserControl = new FormControl('',[Validators.required]);
    this.bankNameDetailControl = new FormControl('');

    this.createBankForm = new FormGroup({
      accountNumberControl: this.accountNumberControl,
      bankNameControl: this.bankNameControl,
      branchControl: this.branchControl,
      accountUserControl: this.accountUserControl,
      bankNameDetailControl: this.bankNameDetailControl,
    });

    if (this.data.mode !== 'create') {
      this.bankService.getBankById(this.data.bankId).subscribe(response => {
        let result = <any>response;
        if (result.statusCode === 202 || result.statusCode === 200) {
          this.bankModel = <BankModel>({
            BankAccountId: result.bankAccount.bankAccountId,
            ObjectId: result.bankAccount.objectId,
            ObjectType: result.bankAccount.objectType,
            AccountNumber: result.bankAccount.accountNumber,
            BankName: result.bankAccount.bankName,
            BranchName: result.bankAccount.branchName,
            AccountName: result.bankAccount.accountName,
            CreatedById: result.bankAccount.createdById,
            CreatedDate: result.bankAccount.createdDate,
            UpdatedById: result.bankAccount.updatedById,
            UpdatedDate: result.bankAccount.updatedDate,
            Active: result.bankAccount.active
          });
        }
      }, error => { });
    }
  }

  onSaveClick() {
    if (this.data.mode === 'create') {
      this.createBank();
    } else {
      this.editBank();
    }
  }
  onCancelClick() {
    this.dialogRef.close(this.data);
  }

  createBank() {
    if (!this.createBankForm.valid) {
      Object.keys(this.createBankForm.controls).forEach(key => {
        if (this.createBankForm.controls[key].valid === false) {
          this.createBankForm.controls[key].markAsTouched();
        }
      });

      let target;

      target = this.el.nativeElement.querySelector('.form-control.ng-invalid');

      if (target) {
        $('html,body').animate({ scrollTop: $(target).offset().top }, 'slow');
        target.focus();
      }
    } else {
      this.bankService.createBank(this.bankModel).subscribe(response => {
        let result = <any>response;
        this.data.message = result.messageCode;
        if (result.statusCode === 202 || result.statusCode === 200) {
          this.data.bankCreated = true;
          this.dialogRef.close(this.data);
        } else {
          this.data.bankCreated = false;
          this.snackBar.openFromComponent(FailComponent, { data: result.messageCode, ...this.failConfig });
        }
      }, error => {
        let result = <any>error;
        this.snackBar.openFromComponent(FailComponent, { data: result.messageCode, ...this.failConfig });
      });
    }
  }

  editBank() {
    if (!this.createBankForm.valid) {
      Object.keys(this.createBankForm.controls).forEach(key => {
        if (this.createBankForm.controls[key].valid === false) {
          this.createBankForm.controls[key].markAsTouched();
        }
      });

      let target;

      target = this.el.nativeElement.querySelector('.form-control.ng-invalid');

      if (target) {
        $('html,body').animate({ scrollTop: $(target).offset().top }, 'slow');
        target.focus();
      }
    } else {
      this.bankService.editBankById(this.bankModel, this.auth.UserId).subscribe(response => {
        let result = <any>response;
        this.data.message = result.messageCode;
        if (result.statusCode === 202 || result.statusCode === 200) {
          this.data.bankEdited = true;
          this.dialogRef.close(this.data);
        } else {
          this.data.bankEdited = false;
          this.snackBar.openFromComponent(FailComponent, { data: result.messageCode, ...this.failConfig });
        }
      }, error => {
        let result = <any>error;
        this.snackBar.openFromComponent(FailComponent, { data: result.messageCode, ...this.failConfig });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/bankpopup/bankpopup.component.ts